/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Result_Action_Dataset_AppendInputs */



/**
* | output |
* | --- |
* | "Add a row to a dataset" |
*
* @param {Agent_Result_Action_Dataset_AppendInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_result_action_dataset_append = /** @type {((inputs?: Agent_Result_Action_Dataset_AppendInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Result_Action_Dataset_AppendInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeile zu einem Datensatz hinzufügen")
	return /** @type {LocalizedString} */ ("Add a row to a dataset")
});